export default "__VITE_ASSET__MNGbCd$6__"